import actionTypes from '../../constants/actions/FDA/FDA'

export function exportarArchivos(values){
  return{ 
    type: actionTypes.EXPORTAR_ARCHIVOS,
    values
  }
}

export default {
  exportarArchivos
}
